import { Outlet } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import { LogOut, User, Settings, Home } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'

const Layout = () => {
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
  }

  const handleHomeClick = () => {
    if (user?.rol === 'admin') {
      navigate('/admin')
    } else if (user?.rol === 'visualizador') {
      navigate('/viewer')
    } else {
      navigate('/dashboard')
    }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center space-x-4">
              <button
                onClick={handleHomeClick}
                className="text-xl font-semibold text-gray-900 hover:text-blue-600 transition-colors duration-200"
              >
                📋 Sistema de Evidencias - Acreditación
              </button>
            </div>
            
            <div className="flex items-center space-x-4">
              {/* Botón Home */}
              <button
                onClick={handleHomeClick}
                className="flex items-center space-x-1 text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                <Home className="h-4 w-4" />
                <span>Inicio</span>
              </button>

              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <User className="h-4 w-4" />
                <span>{user?.correo}</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                  {user?.rol}
                </span>
              </div>
              
              <Link
                to="/change-password"
                className="flex items-center space-x-1 text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm"
              >
                <Settings className="h-4 w-4" />
                <span>Cambiar Contraseña</span>
              </Link>
              
              <button
                onClick={handleLogout}
                className="flex items-center space-x-1 text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm"
              >
                <LogOut className="h-4 w-4" />
                <span>Cerrar Sesión</span>
              </button>
            </div>
          </div>
        </div>
      </nav>
      
      <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <Outlet />
      </main>
    </div>
  )
}

export default Layout